"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputString = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const helpers_1 = require("evolution-common/lib/utils/helpers");
const FormattedInput_1 = __importDefault(require("./FormattedInput"));
const getStateValue = (props) => {
    const value = (0, LodashExtensions_1._isBlank)(props.value)
        ? (0, helpers_1.parseString)(props.widgetConfig.defaultValue, props.interview, props.path, props.user)
        : props.value;
    return (0, LodashExtensions_1._isBlank)(value) ? '' : value;
};
const InputString = (props) => {
    const [value, setValue] = react_1.default.useState(getStateValue(props));
    const inputRef = react_1.default.useRef(props.inputRef || null);
    // Update the value with props when updateKey prop is updated. Not using the
    // `key` to avoid loosing the identity of the component (which causes the
    // focus to get lost)
    react_1.default.useEffect(() => {
        setValue(getStateValue(props));
    }, [props.updateKey]);
    const handleChange = (newValue) => {
        setValue(newValue);
    };
    // Common input props
    const inputProps = {
        type: 'text',
        id: props.id,
        name: props.id,
        value,
        onBlur: props.onValueChange,
        placeholder: props.widgetConfig.placeholder,
        inputMode: props.widgetConfig.keyboardInputMode,
        className: `apptr__form-input apptr__input-string input-${props.widgetConfig.size || 'large'}`,
        maxLength: props.widgetConfig.maxLength ? props.widgetConfig.maxLength : 255,
        style: { textTransform: props.widgetConfig.textTransform || 'none' },
        autoComplete: 'none'
    };
    // Use formatted input only if the inputFilter is defined
    return (0, LodashExtensions_1._isBlank)(props.widgetConfig.inputFilter) ? (react_1.default.createElement("input", Object.assign({}, inputProps, { onChange: (e) => handleChange(e.target.value), ref: inputRef }))) : (react_1.default.createElement(FormattedInput_1.default, Object.assign({}, inputProps, { onChange: handleChange, formatValue: props.widgetConfig.inputFilter, inputRef: inputRef })));
};
exports.InputString = InputString;
exports.default = exports.InputString;
//# sourceMappingURL=InputString.js.map